<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
     Diretoria SBCCV ***
  </app-header-dialog>


  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field style='width: 400px;' appearance="outline">
        <mat-label>Período</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.period"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>